import React from 'react';

export default ({text}) => {
    return (
        <div className={"empty-rows-table valign-wrapper"}>
            <p>{text}</p>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/EmptyState/emptyRows.js